<template>
  <div>
    <div class="relative overflow-hidden" :style="expanded ? null : `max-height: ${maxHeight}px`">
      <slot />
      <div v-if="!expanded" class="bg-gradient-to-t from-white absolute inset-x-0 bottom-0 h-32 pointer-events-none"></div>
    </div>
    <div class="mt-6 text-center">
      <button type="button" class="text-primary hover:underline text-sm font-semibold" @click="expanded = !expanded">
        {{ expanded ? 'Show less ↑' : 'Read more ↓' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleArticle',

  props: {
    maxHeight: { type: Number, default: 760 }
  },

  data() {
    return {
      expanded: false
    }
  }
}
</script>
